<nav
  class="mobile-header lg:hidden"
  [ngClass]="{ 'nav-points-header': isPointsNavShown$ | async }">
  <div class="header-container fixed flex w-full items-center px-0 py-3">
    <button
      class="focus-link inline-flex h-full appearance-none flex-col justify-center border-0 px-3 py-0"
      [ngClass]="{
        invisible: (isFlybuys$ | async)
      }"
      aria-label="Toggle menu here"
      (click)="openSideNav()"
      [attr.aria-hidden]="isSideNavOpen">
      <span class="hamburger-menu-bar inline-block">
        <span></span>
        <span></span>
        <span></span>
      </span>
    </button>
    <span class="header-branding">
      <a
        [routerLink]="bnzNavLinks.home.route"
        role="menuitem"
        class="button typo-emphasis-3-desktop focus-link flex h-full flex-shrink-0 items-end items-center gap-[10px]">
        <img
          [src]="logoImageUrl"
          alt=""
          class="relative h-full w-20 align-baseline" />
      </a>
    </span>

    <ng-container *ifLoggedIn>
      <div *ngIf="!(isFlybuys$ | async)" class="points-summary ml-auto mr-4">
        <div *ngIf="pointsInformation$ | async as pointsInformation">
          <a
            routerLink="/points_activity"
            class="focus-link flex flex-row items-center gap-x-1 no-underline"
            role="menuitem">
            <rd-shared-icon
              *ngIf="isStarIconEnabled"
              iconSymbol="icon-bankwide-rewards-star"
              iconTheme="primary"
              class="block h-6 w-6">
            </rd-shared-icon>

            <span class="typo-emphasis-3-desktop lg:typo-emphasis-1-desktop">
              {{ pointsInformation[0].pointsBalance | localizePointsNumber }}
            </span>
            <span class="lg:typo-text-desktop-2 typo-emphasis-4-desktop">
              {{ pointsInformation[1].name }}
            </span>
          </a>
        </div>
      </div>
    </ng-container>
    <ng-container *ifNotLoggedIn>
      <ng-container *ngIf="!(isFlybuys$ | async)">
        <div
          class="mr-4 flex h-8 w-full flex-grow items-center justify-end gap-4">
          <rd-shared-button
            buttonClass="action-button flex items-center"
            [buttonTheme]="'secondary'"
            [buttonText]="'wl.bnz.header.signup' | translate"
            [redirectURL]="
              'https://www.bnz.co.nz/personal-banking/credit-cards/bnz-advantage'
            "
            [isTargetBlank]="true">
          </rd-shared-button>
          <rd-shared-button
            buttonClass="action-button flex items-center"
            [buttonTheme]="'primary'"
            [buttonText]="'wl.bnz.header.login' | translate"
            (clickFn)="handleUserAction('login')">
          </rd-shared-button></div
      ></ng-container>
    </ng-container>
  </div>

  <mat-sidenav-container class="sidenav-container inset-0" [ngStyle]="style()">
    <mat-sidenav
      #sidenav
      position="start"
      mode="over"
      class="h-full w-full"
      (closedStart)="handleSideNavClose()"
      (openedStart)="handleSideNavOpen()">
      <bnz-side-nav-content
        (sideNavClose)="closeSideNav()"
        (userAction)="handleUserAction($event)"
        [sideNavOpen]="sideNavOpenEvent.asObservable()"
        [isSideNavOpen]="isSideNavOpen">
      </bnz-side-nav-content>
    </mat-sidenav>
  </mat-sidenav-container>
</nav>
